export default Object.freeze({
    Cluster : 'cluster',
})
